<template>
  <div>
    <Top />
    <div class="maindiv znotice-wrap bg-gray">
      <Banner :is-detail="false" />
      <div class="notices mt180 bgw htmldiv">
        <banner-title />
        <div class="cont">
          <Item v-for="(item,index) in news" :key="index" :index="index" :item="item"/>
        </div>
        <!--暂时放一下-->
        <div class="page tcenter">
          <Pagec v-if="total>0" :pagen="page" :size="size" :total="total" :pageClass="'page-blue'" @get-data="getData"/>
        </div>
      </div>
      <div class="ht30"></div>
    </div>
    <Bottom />
  </div>
</template>

<script>
// import Top from "../top";
import Top from '../../index/top.vue'
import Banner from "../banner";
import Bottom from '../../index/bottom'
import Item from "./item";
import BannerTitle from "./ttitle";
import Pagec from "../../index/page";
export default {
  name: "index",
  data () {
    return {
      'news':[],
      'page':1,
      'size':10,
      'total':0,
    }
  },
  components:{
    Top,
    Banner,
    Bottom,
    Item,
    BannerTitle,
    Pagec,
  },
  created() {
    this.getData(1);
  },
  methods:{
    getData(page){
      var getParam = {};
      getParam['theme'] = 1;
      getParam['type'] = 1;
      getParam['page'] = page - 1;
      getParam['size'] = this.size;
      this.$request.get('article/list',getParam,response => {
        if(response.status == 200){
          this.news = response.data.data.noticeList;
          this.total = response.data.data.count;
        }
      },error => {
        console.log(error);
      })
    },
  }
}
</script>

<style scoped>
  .znotice-wrap .notices{padding: 40px 50px 0 35px;}
  .znotice-wrap .notices .cont{padding: 60px 0 80px 20px;}
  .notices .ncont{padding: 40px 20px;line-height: 2.5;}
</style>



// WEBPACK FOOTER //
// src/components/main/news/index.vue